/** Shopify CDN: Minification failed

Line 46:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 47:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 47:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 48:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 48:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 50:51 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 57:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 64:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 66:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 67:12 Transforming const to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 31:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 33:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 33:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 35:51 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 42:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 49:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 51:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 52:12 Transforming const to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 16:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 17:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 18:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 18:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 20:51 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 27:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 34:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 36:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 37:12 Transforming const to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
(async () => {
    const { Core } = await importModule('Core');
    const { Routes } = await importModule('Utils');

    customElements.define('contact-form-submiter', class extends Core {
        elements = {
            form: '[data-contact-form]',
            formTargeter: '[data-contact-form-targeter]',
            inputs: '*[data-input]'
        }

        render() {
            if (!this.$form) {                
                this.$form = this.$formTargeter.form;
            }
            this.$form.addEventListener('submit', this._handleSubmit.bind(this));
        }

        async _handleSubmit(e) {
            e.preventDefault();
            const formData = new FormData(e.target);
            const { url } = await this._send(formData);
            url.includes('challenge') ? e.target.submit() : this._success();
        }
        
        async _send(formData) {
            try {
                return await fetch(Routes('contact'), { method: 'POST', body: formData });
            } catch ({ message }) {
                console.error(message);
            }
        }
        
        _success() {
            this._publishNotification();
            this._clearInputs()
        }

        _publishNotification() {
            this.publish('toast-notification:open', {  
                    title: this.succesTitle,
                    message: this.succesMsg, 
                    type: 'success' 
                }
            )
        }

        _clearInputs() {
            this.$inputs.map($input => $input.value = '')
        }

        get succesMsg() {
            return this.getAttribute('success-message') || '';
        }

        get succesTitle() {
            return this.getAttribute('success-title') || '';
        }
    })

})();
